"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTokenValidationOnFocus = useTokenValidationOnFocus;
var _react = require("react");
var _reactRedux = require("react-redux");
var _user = require("../actions/user");
// Custom hook for token validation on tab focus
function useTokenValidationOnFocus(enable) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var checkTokenValidity = (0, _react.useCallback)(function () {
    dispatch((0, _user.validateUserToken)());
  }, [dispatch]);
  var onFocusChange = (0, _react.useCallback)(function () {
    if (document.visibilityState === 'visible') {
      // Check token validity when tab gains focus
      checkTokenValidity();
    }
  }, [checkTokenValidity]);
  (0, _react.useEffect)(function () {
    if (enable) {
      // Add event listener for visibility change
      document.addEventListener('visibilitychange', onFocusChange);

      // Cleanup function to remove event listener when component unmounts
      return function () {
        document.removeEventListener('visibilitychange', onFocusChange);
      };
    }
  }, [enable, onFocusChange]);
}